<template>
  <div>
    <v-app-bar>
      <img
        class="cursor-pointer"
        :src="$operatorLogoUrl(domain)"
        aspect-ratio="1"
        :alt="domain"
        v-on:click="$router.push('/')"
        :style="{
          'max-width': $vuetify.breakpoint.smAndDown ? '200px' : '200px',
          'max-height': '48px',
        }"
      />
      <v-btn
        class="ml-4 cursor-pointer"
        color="primary"
        small
        @click="$router.push('/')"
      >
        {{ $t("knowUs") }}
      </v-btn>

      <div class="flex-grow-1"></div>
      <v-toolbar-title class="ml-4 cursor-pointer">
        {{ $t("register") }}
      </v-toolbar-title>
    </v-app-bar>
    <v-main>
      <v-container
        :class="{
          'pa-0': $vuetify.breakpoint.width < 600 && $isCreditOnline(),
          'd-flex justify-center': $isCreditOnline()
        }"
      >
      <NewRegisterForm v-if="$isCreditOnline()" :hideToolbarDialogProp="true" />
      <RegisterForm v-else />
      </v-container>
    </v-main>
  </div>
</template>
<script>
import RegisterForm from "@/views/home/register";
import NewRegisterForm from "@/views/home/register/newRegisterForm";

export default {
  name: "RegisterPlayerFromAgent",
  components: {
    RegisterForm,
    NewRegisterForm,
  },
  data: () => ({
    domain: "",
  }),
  mounted() {
    this.domain = this.$domain();

    if (this.$route.params.affiliate_id) {
      localStorage.setItem("affiliateId", this.$route.params.affiliate_id);
    }
  },
};
</script>